import { FormEvent } from "react";

import { Feedback } from "@/api/models";

interface ReportInappropriateFeedbackContentProps {
  negativeFeedbackList: Feedback[];
  updateFeedbackList: (ev?: FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => void;
}

const ReportInappropriateFeedbackContent = ({ negativeFeedbackList, updateFeedbackList }: ReportInappropriateFeedbackContentProps) => {
  return (<>
    <div>The content is:</div>
    <div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.HateSpeech} defaultChecked={negativeFeedbackList.includes(Feedback.HateSpeech)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Hate speech, stereotyping, demeaning</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.Violent} defaultChecked={negativeFeedbackList.includes(Feedback.Violent)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Violent: glorification of violence, self-harm</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.Sexual} defaultChecked={negativeFeedbackList.includes(Feedback.Sexual)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Sexual: explicit content, grooming</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.Manipulative} defaultChecked={negativeFeedbackList.includes(Feedback.Manipulative)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Manipulative: devious, emotional, pushy, bullying</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.OtherHarmful} defaultChecked={negativeFeedbackList.includes(Feedback.OtherHarmful)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Other</span>
        </label>
      </div>
    </div>
  </>);
}

export default ReportInappropriateFeedbackContent;